__turbopack_context__.v({
  "buttonText": "STFileUpload-module__Hs56-W__buttonText",
  "errorText": "STFileUpload-module__Hs56-W__errorText",
  "hiddenInput": "STFileUpload-module__Hs56-W__hiddenInput",
  "icon": "STFileUpload-module__Hs56-W__icon",
  "label": "STFileUpload-module__Hs56-W__label",
  "uploadButton": "STFileUpload-module__Hs56-W__uploadButton",
  "uploadWrapper": "STFileUpload-module__Hs56-W__uploadWrapper",
});
